import { memo } from "react";
import { Modal } from "react-bootstrap";

import SetState from "../typings/SetState";
import ButtonComponent from "./ButtonComponent";

type ConfirmModalProps = {
  show: boolean;
  onClose: SetState<boolean>;
  title: string;
  text: JSX.Element | string;
  onClick: () => void;
};

const ConfirmModal = ({
  show,
  onClose,
  title,
  text,
  onClick,
}: ConfirmModalProps) => {
  return (
    <Modal show={show} onHide={() => onClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        <ButtonComponent onClick={() => onClose(false)}>Cancel</ButtonComponent>
        <ButtonComponent onClick={() => onClick()}>Yes</ButtonComponent>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(ConfirmModal);
